import { api } from './api.js';
import { state } from './state.js';
import { navigate } from './router.js';

// Кнопка «Обсудить с учителем» и список прошлых обсуждений.
//
// Сам разговор живёт на отдельном экране (/talk/:id): в панели под разбором он
// был тесен — реплики длинные, поле ввода уезжало за край, а страница под
// руками продолжала жить своей жизнью. Здесь остался только вход.
export const Talk = {
  props: {
    session: { type: Number, default: 0 },
    question: { type: Number, default: 0 },
  },
  data() { return { talks: [], loading: true, error: '', starting: false }; },
  computed: {
    where() { return this.session ? `session=${this.session}` : `question=${this.question}`; },
  },
  async created() {
    try {
      const { rows } = await api.get(`/api/talks/${state.projectId}/list?${this.where}`);
      this.talks = rows;
    } catch (e) { this.error = e.message; }
    finally { this.loading = false; }
  },
  methods: {
    /** Новое обсуждение. Их может быть сколько угодно: вопросы приходят волнами. */
    async start() {
      if (this.starting) return;
      this.starting = true;
      try {
        const body = this.session ? { session: this.session } : { question: this.question };
        const { talk } = await api.post(`/api/talks/${state.projectId}/start`, body);
        navigate(`/talk/${talk.id}`);
      } catch (e) { this.error = e.message; this.starting = false; }
    },
    open(id) { navigate(`/talk/${id}`); },
    when(row) {
      return new Date(row.created_at).toLocaleDateString('ru-RU',
        { day: 'numeric', month: 'short' });
    },
  },
  template: `
    <div class="talk">
      <button class="btn sm" :disabled="starting" @click="start">
        {{ starting ? 'открываю…' : 'Обсудить с учителем' }}
      </button>
      <template v-if="talks.length">
        <span class="faint">раньше:</span>
        <button class="link" v-for="t in talks" :key="t.id" @click="open(t.id)">
          {{ when(t) }} · {{ t.реплик }}
        </button>
      </template>
      <span class="err" v-if="error">{{ error }}</span>
    </div>
  `,
};
